import React from "react";

const PartnerRealtorIcon = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="white" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M18.8513 27.0841C17.6016 26.2028 16.665 24.9465 16.1771 23.4973C15.6892 22.048 15.6754 20.4811 16.1376 19.0234C16.5999 17.5658 17.5143 16.2932 18.7482 15.39C19.9822 14.4869 21.4716 14 23.0008 14C24.53 14 26.0194 14.4869 27.2534 15.39C28.4873 16.2932 29.4016 17.5658 29.8639 19.0234C30.3262 20.4811 30.3124 22.048 29.8245 23.4973C29.3366 24.9465 28.3999 26.2028 27.1502 27.0841L29.0249 31.368C29.055 31.4366 29.0676 31.5116 29.0613 31.5863C29.0551 31.6609 29.0304 31.7328 28.9894 31.7955C28.9483 31.8581 28.8923 31.9095 28.8264 31.9451C28.7605 31.9806 28.6867 31.9991 28.6118 31.999H17.3888C17.3141 31.9991 17.2404 31.9805 17.1746 31.9451C17.1088 31.9096 17.0529 31.8582 17.0118 31.7957C16.9708 31.7332 16.9461 31.6614 16.9398 31.5869C16.9335 31.5124 16.9458 31.4375 16.9757 31.3689L18.8504 27.0841H18.8513ZM24.9128 26.4604L26.1116 25.6135C27.0492 24.9527 27.752 24.0105 28.1182 22.9236C28.4844 21.8366 28.4949 20.6612 28.1484 19.5678C27.8018 18.4745 27.116 17.5198 26.1905 16.8423C25.265 16.1648 24.1478 15.7995 23.0008 15.7995C21.8538 15.7995 20.7366 16.1648 19.811 16.8423C18.8855 17.5198 18.1998 18.4745 17.8532 19.5678C17.5066 20.6612 17.5172 21.8366 17.8834 22.9236C18.2496 24.0105 18.9524 24.9527 19.8899 25.6135L21.0878 26.4604L19.4525 30.1989H26.5481L24.9128 26.4604ZM19.5074 22.072L21.2534 21.6355C21.3503 22.0255 21.575 22.3719 21.8915 22.6194C22.2081 22.867 22.5984 23.0015 23.0003 23.0015C23.4022 23.0015 23.7925 22.867 24.1091 22.6194C24.4257 22.3719 24.6503 22.0255 24.7472 21.6355L26.4932 22.072C26.2974 22.85 25.8475 23.5404 25.2147 24.0336C24.582 24.5269 23.8026 24.7948 23.0003 24.7948C22.198 24.7948 21.4187 24.5269 20.7859 24.0336C20.1532 23.5404 19.7032 22.85 19.5074 22.072Z"
        fill="#525866"
      />
    </svg>
  );
};

export default PartnerRealtorIcon;
